import React, { useMemo } from "react";
import useFinancialTransactions from "../../hooks/useFinancialTransactions";
import { TRANSACTION_TYPES } from "../../constants/transactionTypes";
import styles from "./OverviewTab.module.css";

const OverviewTab = () => {
  const { transactions, loading } = useFinancialTransactions(); // كل الأنواع

  const { totalExpense, totalRevenue, net } = useMemo(() => {
    const totalExpense = transactions
      .filter((t) => t.transactionType === TRANSACTION_TYPES.EXPENSE)
      .reduce((sum, t) => sum + t.amount, 0);

    const totalRevenue = transactions
      .filter((t) => t.transactionType === TRANSACTION_TYPES.REVENUE)
      .reduce((sum, t) => sum + t.amount, 0);

    return { totalExpense, totalRevenue, net: totalRevenue - totalExpense };
  }, [transactions]);

  if (loading) return <p>جاري التحميل...</p>;

  return (
    <div className={styles.container}>
      <div className={styles.cards}>
        <div className={`${styles.card} ${styles.revenue}`}>
          <span>إجمالي الإيرادات</span>
          <h2>{totalRevenue.toLocaleString()} ج.م</h2>
        </div>
        <div className={`${styles.card} ${styles.expense}`}>
          <span>إجمالي المصروفات</span>
          <h2>{totalExpense.toLocaleString()} ج.م</h2>
        </div>
        <div className={`${styles.card} ${net >= 0 ? styles.positive : styles.negative}`}>
          <span>الصافي</span>
          <h2>{net.toLocaleString()} ج.م</h2>
        </div>
      </div>

      <h3 className={styles.recentTitle}>آخر العمليات</h3>
      <ul className={styles.recentList}>
        {transactions.slice(0, 5).map((t) => (
          <li key={t.id}>
            <span>{t.title}</span>
            <span className={t.transactionType === TRANSACTION_TYPES.EXPENSE ? styles.neg : styles.pos}>
              {t.transactionType === TRANSACTION_TYPES.EXPENSE ? "-" : "+"}{t.amount}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default OverviewTab;